import React, { FC } from "react";

import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from "recharts";

const totalColors = "#e84296";
const newUsersColors = "#8884d8";
const returningUsersColors = "#82ca9d";

export interface Data {
    orgId: string;
    date: string;
    newUsers: number;
    returningUsers: number;
    total: number;
}

export interface Margin {
    top: number;
    right: number;
    left: number;
    bottom: number;
}

export interface GraphProps {
    data: Data[];
    width: number;
    height: number;
    margin: Margin;
}

export const Graph: FC<GraphProps> = props => {
    const { data, width, height, margin } = props;
    return (
        <LineChart width={width} height={height} margin={margin} data={data || []}>
            <XAxis dataKey="date" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend />
            <Line name="Total" type="monotone" dataKey="total" stroke={totalColors} activeDot={{ r: 3 }} />
            <Line name="New Users" type="monotone" dataKey="newUsers" stroke={newUsersColors} activeDot={{ r: 8 }} />
            <Line name="Returning Users" type="monotone" dataKey="returningUsers" stroke={returningUsersColors} />
        </LineChart>
    );
};
